export enum FeatureToggle {
  BENES_BY_RELATION = 'benes_by_relation',
  SAVE_AS_DRAFT = 'save_as_draft',
  CONTROL_PERSON = 'control_person',
  GIFTING = 'gifting',
  GIFTING_SCALE_TOGGLE_V2 = 'gifting_scale_v2',
  INTERNAL_TRANSFER_DIFFERENT_OWNERS_TOGGLE = 'internal_transfer_different_owners',
  INTERNAL_TRANSFER_STP_TOGGLE = 'internal_transfer_stp',
  CWP_IRA_SCALE_TRAD = 'cwp_ira_scale_trad',
  CWP_IRA_SCALE_INH_ROTH = 'cwp_ira_scale_inh_roth',
  INTERNAL_TRANSFER_IT_JOINT_TOGGLE = 'internal_transfer_joint',
  INTERNAL_TRANSFER_IT_TRUST_TOGGLE = 'internal_transfer_trust',
  INHERITANCE_ESTATE_SCALE_TOGGLE = 'cwp_ira_scale_estate',
  CWP_UPDATED_MXM_ENABLEMENT = 'cwp_updated_mxm_enablement',
  CWP_IRA_SCALE_TRUST = 'cwp_ira_scale_trust',
  JOINT_INHERITANCE = 'joint_inheritance',
  INHERITANCE_IRA = 'inheritance_ira',
  INHERITANCE_INDIVIDUAL = 'inheritance_individual',
  CASH_PLUS_INTERNAL_TRANSFER = 'cash_plus_internal_transfer',
  CWP_IRA_SCALE_TRUST_TO_TRUST = 'cwp_ira_scale_trust_to_trust',
  CWP_INTERNAL_GIFTING_MANAGED_ACCOUNTS = 'cwp_internal_gifting_managed_accounts',
  INTELLEDOX_REDIRECT_AND_THRESHOLDS = 'intelledox_redirect_and_thresholds',
  VCD_SETTLEMENT_FUNDS = 'vcd_settlement_funds',
  DOC_CHECKLIST_INHERITANCE = 'doc_checklist_inheritance',
  CWP_MULTI_INHERITANCE = 'cwp_multi_inheritance',
  CWP_IT_ESTATE_SCALE = 'cwp_it_estate_scale',
  CWP_UGMA_UTMA_IT = 'cwp_ugma_utma_it',
  CWP_CO0_MINOR = 'cwp_co0_minor',
  CWP_CO0_INHERITANCE = 'cwp_co0_inheritance',
  CWP_CO0_INTERNAL_TRANSFERS = 'cwp_co0_internal_transfers',
  CWP_CO0_UPLOAD = 'cwp_co0_upload',
  TO_FROM_CONSOLIDATION = 'to_from_consolidation',
  CWP_CO0_GIFTING = 'cwp_co0_gifting',
  CWP_DIVORCE = 'cwp_divorce',
  CWP_INHERITANCE_HIDE_SINGLE_FLOW = 'cwp_inheritance_hide_single_flow',
}

export const FeatureToggleObject = Object.keys(FeatureToggle).reduce((obj, key) => {
  return {
    ...obj,
    [key]: FeatureToggle[key as keyof typeof FeatureToggle],
  };
}, {});
